import Pubsub from './pubsub.js';
export default new Pubsub();